import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./components/Routes";

import Theme from "./contexts/theme";
import Language from "./contexts/language";

import Boarding from "./views/Boarding";
import Tour from "./views/Tour";

import "./css/App.css";
import Experience from "./contexts/experience";

export default function Ui() {
  return (
    <Contexts>
      <Routes test="root" views={views} />
    </Contexts>
  );
}

function Contexts({ children }) {
  return (
    <Language>
      <Theme>
        <Experience>
          <Router>{children}</Router>
        </Experience>
      </Theme>
    </Language>
  );
}

const views = [
  {
    name: "Boarding",
    path: ["/boarding"],
    component: Boarding,
  },
  {
    name: "Tour",
    path: "/tour",
    component: Tour,
  },
];
